// extracted by mini-css-extract-plugin
export default {"inputContainer":"Input_inputContainer__3dWQk","inputClass":"Input_inputClass__oRTPJ","label":"Input_label__KaNQ+","subscribeForm":"Input_subscribeForm__vP-t7"};